<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 25.5H23" stroke="black" stroke-width="2"/>
<path d="M15 5L15 20M15 20L21 14M15 20L9 14" stroke="black" stroke-width="2"/>
</svg>
